import styled from 'styled-components';
import colors from '@service-victoria/component-library/utils/colors';
import CircleTick from '@service-victoria/component-library/components/Icons/CircleTick';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  ul {
    margin-top: 0;
    color: ${colors.blueGrey};
  }
`;

export const HeadingWrapper = styled(Wrapper)`
  min-height: 100%;
  margin-bottom: 32px;
`;

export const CustomLink = styled(Link)`
  color: ${colors.brown};
`;

export const Spacer8 = styled.div`
  padding-bottom: 8px;
`;

export const Spacer16 = styled(Wrapper)`
  margin-bottom: 16px;
`;

export const Spacer24 = styled(Wrapper)`
  margin-bottom: 24px;
`;

export const Spacer32 = styled(Wrapper)`
  margin-bottom: 32px;
`;

export const Spacer48 = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const ContentWrapper = styled(Wrapper)`
  margin-bottom: 48px;
`;

export const DoneWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TickWrapper = styled(CircleTick)`
  width: 45px;
  height: 45px;
  margin-right: 16px;
`;

export const Error = styled.div`
  > div {
    margin-top: 0;
  }
`;

export const List = styled.ul`
  padding-left: 0px 40px 0 6px;
  margin-top: -12px;
`;

export const ListOrdered = styled.ol`
  padding-left: 0px 40px 0 6px;
  margin-top: -12px;
`;

export const ListItem = styled.li`
  padding: 6px 0;

  > div {
    display: inline-flex;
    > a {
      margin-right: 0;
    }
  }
`;

export const TextBodyWithInlineLink = styled.div`
  margin: 16px 0;
  color: #3c4a60;
  > div {
    display: inline-flex;
  }
`;

export const InputContainer = styled.div`
  padding: 8px 0;
`;
